import Head from 'next/head';
import Layout from 'components/layout';
import Preview from 'components/preview';
import Banner from 'components/banner';
import ContactBtnGroup from 'components/contact';
import { partnerBanner, partnerBannerMobile } from 'constants/index';
import style from 'styles/sales/partner.module.scss';
export default function Home() {
  return (
    <Layout>
      <Head>
        <title>伙伴政策 - 小鱼易连-官网-让世界零距离</title>
      </Head>
      <section>
        <Banner title="合作伙伴" bgImage={partnerBanner} bgImageMobile={partnerBannerMobile} />
        <Preview
          isImgView={false}
          classNames={style.content}
          detail={{
            id: '1',
            content:
              '<h4>伙伴政策</h4>\n<p>随着4G网络的普及和5G的快速发展，移动视频时代已经到来。移动视频应用深入各行各业，消除时间与空间的限制，改变企业沟通方式， 创造新的商业模式。远程银行、远程医疗、远程教育和视频客服成为现实。</p>\n<p>企业视频会议市场飞速增长，&ldquo;SaaS云服务+智能视频硬件&rdquo;视频应用新模式成为新的&ldquo;蓝海&rdquo;。小鱼易连依托专业的音视频技术、创新的智能硬件、全球部署的云服务与极简用户体验，秉承“建设有核心自主知识产权的高科技民族企业”的使命，用科技振兴民族，让世界零距离。</p>\n<p>全面分销、伙伴共赢，小鱼易连愿与合作伙伴共享千亿级移动视频应用市场。</p>\n<h4>支持政策</h4>\n<p>市场体验支持：市场费用分担、体验中心支持、市场工具支持</p>\n<p>业务开展支持：销售工具支持、战略项目支持、批量客户定制、商机信息推送</p>\n<p>管理运营支持：运营方案指导、核心伙伴年会、业务经营规划</p>\n<h4>合作热线</h4>\n<p>400-900-3567</p>',
          }}
        />
        <ContactBtnGroup />
      </section>
    </Layout>
  );
}
